import { render, staticRenderFns } from "./Cupons.vue?vue&type=template&id=79885739&scoped=true"
import script from "./Cupons.vue?vue&type=script&lang=js"
export * from "./Cupons.vue?vue&type=script&lang=js"
import style0 from "./Cupons.vue?vue&type=style&index=0&id=79885739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79885739",
  null
  
)

export default component.exports